// extracted by mini-css-extract-plugin
export default {"userBlock":"userBlock_userBlock__KHfT-"};